import { Divider, Stack, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import MenuPopover from "src/components/MenuPopover";
import useLocales from "src/hooks/useLocales";
import { AppType } from "src/types/apps";

import Context from "../context";
import AppMenuItem from "./AppMenuItem";
import CreateAppItem from "./CreateAppItem";
// ----------------------------------------------------------------------

export default function SelectAppMenu() {
	const { state, actions } = useContext(Context);
	const { translate } = useLocales();

	const { data: apps } = useQuery<AppType[]>({ queryKey: ["apps"], initialData: [] });

	return (
		<MenuPopover
			anchorEl={state.showSelectAppMenu}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "center"
			}}
			disabledArrow
			arrow='left-bottom'
			onClose={actions.hideSelectAppMenu}
			open={Boolean(state.showSelectAppMenu)}
			transformOrigin={{
				vertical: "bottom",
				horizontal: 0
			}}
		>
			<Typography variant='subtitle2' sx={{ px: 2, py: 1 }}>
				{translate("nav_app_section.select_app")}
			</Typography>
			<Divider sx={{ borderStyle: "dashed", my: 1 }} />
			<Stack gap={0.5}>
				{apps.map((option) => (
					<AppMenuItem app={option} key={option.id} />
				))}
			</Stack>
			{apps.length < 5 && (
				<>
					<Divider sx={{ borderStyle: "dashed", my: 1 }} />
					<CreateAppItem />
				</>
			)}
		</MenuPopover>
	);
}
